import {Component} from '@angular/core';

import {Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';
import {KmOrMiles} from '../../core/enum/km-miles.enum';
import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {UnrSettingsService} from '../../services/settings/settings.service';
import {ModalController, Platform} from '@ionic/angular';
import {UnrSettingRecordingAccuracyModalComponent} from '../../shared/modal/rating/setting-recording-accuracy-modal.component';
import {UnrModalComponent} from '../../shared/modal/unr-modal.component';
import {UnrModalDismissEventEnum} from '../../shared/modal/unr-modal-dismiss-event.enum';
import {SettingKeyEnum} from '../../services/settings/setting-key.enum';


@Component({
  selector: 'unr-settings',
  templateUrl: 'settings.html',
  styleUrls: [
    'settings.scss'
  ]
})
export class SettingsPage {

  isMiles: boolean;
  recordingAccuracy = 20;
  showWelcomeScreen = true;

  private getKmOrMilesSubscription: Subscription;
  private locationAccuracySubscription: Subscription;
  private showWelcomeScreenSubscription: Subscription;

  constructor(private settingsService: UnrSettingsService,
              private statusbarService: StatusbarService,
              private modalController: ModalController,
              private platform: Platform) {
  }

  ionViewWillEnter(): void {
    if (this.platform.is('ios')) {
      this.statusbarService.changeStatusBar({ style: '' });
    } else {
      this.statusbarService.changeStatusBar({ style: '' });
    }
    this.subscribeToKmOrMiles();
    this.subscribeToLocationAccuracy();
    this.subscribeToShowWelcomeScreen();
  }

  ionViewWillLeave(): void {
    this.getKmOrMilesSubscription && this.getKmOrMilesSubscription.unsubscribe();
    this.locationAccuracySubscription && this.locationAccuracySubscription.unsubscribe();
    this.showWelcomeScreenSubscription && this.showWelcomeScreenSubscription.unsubscribe();
  }

  onKmOrMilesToggleChange($event: CustomEvent): void {
    this.settingsService.saveSetting(SettingKeyEnum.KM_OR_MILES, $event.detail.checked);
  }

  setShowWelcomeScreen($event: CustomEvent) {
    this.settingsService.saveSetting(SettingKeyEnum.SHOW_WELCOME_SCREEN, $event.detail.checked);
  }

  async recordingAccuracyClick(): Promise<void> {
    const modal: HTMLIonModalElement = await this.modalController.create({
      component: UnrSettingRecordingAccuracyModalComponent,
      componentProps: {invertedValue: this.settingsService.getLatestCoordinatesAccuracy()},
      backdropDismiss: true,
      showBackdrop: true,
      cssClass: 'modal--popup'
    });
    await modal.present();
    const dismissData = await modal.onDidDismiss();
    if (dismissData.data[UnrModalComponent.DISMISS_DATA_KEY] === UnrModalDismissEventEnum.Primary) {
      const value = dismissData.data[UnrModalComponent.DISMISS_VALUE_KEY];
      this.settingsService.saveSetting(SettingKeyEnum.RECORDING_ACCURACY, value);
      this.settingsService.setCoordinatesAccuracy(value);
    }
  }

  private subscribeToShowWelcomeScreen(): void {
    this.showWelcomeScreenSubscription = this.settingsService
      .getShowWelcomeScreenAsObservable()
      .pipe(
        tap((showWelcomeScreen: boolean) => this.showWelcomeScreen = showWelcomeScreen)
      ).subscribe();
  }

  private subscribeToLocationAccuracy(): void {
    this.locationAccuracySubscription = this.settingsService
      .getCoordinatesAccuracy()
      .pipe(
        tap((accuracy: number) => this.recordingAccuracy = accuracy)
      ).subscribe();
  }

  private subscribeToKmOrMiles(): void {
    this.getKmOrMilesSubscription = this.settingsService
      .getKmOrMiles()
      .pipe(
        tap((kmOrMiles: KmOrMiles) => this.isMiles = kmOrMiles === KmOrMiles.MILES)
      ).subscribe();
  }
}
